import classes from "./TermsAndConditions.module.css";
import { Link } from "react-router-dom";
import BreadCrumbComp from "../components/BreadCrumbComp";
import PageSchema from "../components/PageSchema";

export default function TermsAndConditions() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="Terms & Conditions - Prime Cloud Systems Online IT Hardware Purchases"
        description="Read the comprehensive Terms & Conditions of Prime Cloud Systems, covering purchase guidelines, responsibilities, and online shopping rules for servers, PCs, and networking products."
        url="https://primecloudsystems.com/terms-and-conditions"
        breadcrumbs={[
          { name: "Home", url: "https://primecloudsystems.com/" },
          {
            name: "Terms & Conditions",
            url: "https://primecloudsystems.com/terms-and-conditions",
          },
        ]}
      />

      <BreadCrumbComp
        currentPage="Terms and Conditions"
        title="Terms & Conditions | Prime Cloud Systems"
        description="Read Prime Cloud Systems’ Terms & Conditions to understand policies on IT hardware, networking equipment, services, and user responsibilities, ensuring transparency and reliable service."
      />

      <div className={`container ${classes.TermsAndConditionsContainer}`}>
        <p className={classes.paragraph}>
          Following are the rules concerning the right use of the{" "}
          <Link to={"https://www.primecloudsystems.com"}>
            <b>www.primecloudsystems.com</b>
          </Link>{" "}
          website, our offered products and services, included but not limited
          to, our product directory, listings, and external links redirecting
          users to any other website.
        </p>
        <p className={classes.paragraph}>
          When using our website, you agree to abide by the mentioned terms and
          Conditions of Use of the Site (TCUS), included but not limited to, our
          privacy policy, other mentioned guidelines that we may review and
          change with time, compiled and written herein for your reference, and
          you also agree to follow our applicable rules and regulations
          mentioned on{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>
          . We request you to not enter or use our website if you disagree to
          our Terms and Conditions of Use.
        </p>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>
          , (“Prime Cloud Systems LLC”) reserves the right to change its TCUS
          every so often, if need be. Users hold the responsibility of checking
          our site from time to time to learn about the new updates and changes
          done on the website. Following the changes in{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>
          ,
        </p>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>{" "}
          TCUS , your presence and USA of the website will be deemed as an
          acceptance of any change(s).
        </p>
        <p className={classes.paragraph}>
          Users below the age of 13 are strictly banned from the use of our
          website, from any posting of personal and identifiable information.
          Our website is not intended for use by individuals aged 13, or under.
        </p>
        <h2 className={classes.subheading}>Access Rights and Authorization</h2>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>
          , (“Prime Cloud Systems LLC”) allows users an inclusive right and
          authorization to browse and access the website for any personal,
          commercial, or non-commercial, included but not limited to, purchase
          of items for use or re-sale. However, our access rights and
          authorization strictly excludes the following actions: resale of the
          website or its respective contents
        </p>
        <ul className={classes.subItem}>
          <li>
            bans the collection and use of its product listings, titles,
            descriptions, and prices, unless specifically authorized
          </li>
          <li>
            plagiarized, copied use of our website or its respective contents
          </li>
          <li>
            restricts data mining, robots, data gathering, and extraction tools.
          </li>
        </ul>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>primeCloudSystems</b>
          </Link>
          , (“Prime Cloud Systems LLC”) , as whole, including but not limited
          to, its operations and processes, interface, contents, is entirely
          covered under the US copyright law and international law and treaty.
          It shall not be, in any way, reproduced, replicated, initiated, sold,
          exploited, maliciously visited, or resold for any illegal and
          non-acceptable purposes unless consented.
        </p>{" "}
        <p className={classes.paragraph}>
          Any malicious and illegal use of the website shall immediately result
          in the license’s termination and rights allowed by the company, and
          may possibly subject you to legal trial and examination.
        </p>
        <p className={classes.paragraph}>
          You are allowed a restricted, revocable, and inclusive option to make
          hyperlinks to any page of the website as long as the created link
          restricts the display of the website, the Company, its associates,
          partners, co-brand accomplices, Licensors, and any other partners, its
          products and services, in a deceiving, harsh, or in any way, invasive,
          or harming way.
        </p>
        <p className={classes.paragraph}>
          You shall not use any Licensor, associate, subsidiary, co-brand
          partner, partner logo, or registered graphic or trademark associated
          with [website Name], as part of a link to the website unless otherwise
          allowed in written form by the Company, its subsidiary, associate,
          co-brand partner, or other partner or Licensor.
        </p>
        <h2 className={classes.subheading}>Product Listings and Content</h2>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          aims to provide accurate information about all products offered on the
          website, including descriptions, titles, images, prices, links,
          compatibility details, and other relevant information. However, due to
          human error or technical issues, we cannot guarantee that all
          information on the website is completely accurate, reliable,
          up-to-date, or error-free.
        </p>
        <p className={classes.paragraph}>
          The content provided by{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          is for informational purposes only and does not constitute an
          endorsement of any product, service, reseller, manufacturer, or other
          entity.{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          is not responsible for any inaccuracies, errors, or omissions in
          product information, titles, descriptions, or prices.
        </p>
        <p className={classes.paragraph}>
          In the event of incorrect or inaccurate information, including pricing
          errors due to typographical, technical, or other mistakes,{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          reserves the right to reject or cancel any orders for the affected
          product or service and to update the information at its discretion.
        </p>
        <h2 className={classes.subheading}>Links to Sites and Businesses</h2>
        <p className={classes.paragraph}>
          To help users make their purchase decision, our website includes links
          (hyperlinks) to other manufacturers websites, informational
          third-party blog sites, review sites, associated companies and partner
          sites, and other sources. Each link provided by the Company is solely
          for informational purposes and for customers help. It is clear that
          the Company does not, in any way, associates these links with any
          endorsements for the third party sites’ content or for their business
          practices.
        </p>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          accepts no obligations and responsibilities towards assessing such
          content or other businesses. The Company, in no way, warrants or
          guarantees any accountability regarding the offered product or
          service, endorsements, business practices of any linked entity, its
          individual, or its offered contents on website(s). It is your
          obligation to read and assess their TCUS and privacy policy
          statements.
        </p>
        <p className={classes.paragraph}>
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          owns no control or authority over the businesses linked to its Site or
          any of their business operations and processes. The Company, in no
          way, controls or takes responsibility for the contents, legality, and
          safety of the products and services offered on the hyperlinked website
          or business, neither does it take charge or control business
          transactions carried out on the linked businesses and websites.
        </p>
        <p className={classes.paragraph}>
          In case of any disagreement or misconduct between a user and any
          business site redirected to, through{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems.com</b>
          </Link>{" "}
          , to any maximum extent permitted by the applicable law, the user
          holds innocent and discharge{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          . its members, subsidiaries, associates, or any other affiliated
          parties, its respective officers, executives, workers, agents, or
          legal representatives, from any or from all dues and statements or
          damages, whether known or unknown, suspected or unsuspected, emerging
          out of or in any way associated with any such misconduct or
          disagreement.
        </p>
        <p className={classes.paragraph}>
          If in case the said user is a California resident using our site, you
          hereby waive the rights granted under the California Civil Code 1542,
          stating “A general release does not extend to claims which the
          creditor does not know or suspect to exist in his favor at the time of
          executing the release, which, if known by him, must have materially
          affected his settlement with the debtor”.
        </p>
        <h2 className={classes.subheading}>Brand Trademark</h2>
        <p className={classes.paragraph}>
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          trademarks, service marks, logos, and graphics that appear on the{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          website are all registered trademarks of{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          Inc. Any use of, or linking to,{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          trademarks or to the{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          website must comply with the Terms and Conditions of Use (TCUS).
        </p>{" "}
        <p className={classes.paragraph}>
          You cannot purchase{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          brand name, trademark, language syntax, contents, nor can you create
          its byproducts, or purchase its mentioned keywords to drive traffic to
          its competitors.
        </p>
        <h2 className={classes.subheading}>Order Acknowledgement</h2>
        <p className={classes.paragraph}>
          When you purchase a product from the product listings on{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          , you will receive an order acknowledgement. This acknowledgement
          confirms that your order has been received, but it is not a contract
          and does not constitute acceptance of your order. It serves solely as
          a record of your purchase, including the items and pricing.
        </p>
        <p className={classes.paragraph}>
          After placing an order,{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          will determine whether to fulfill it.{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          reserves the right to cancel or limit any order for any reason, which
          may not necessarily be disclosed.
        </p>
        <p className={classes.paragraph}>
          By placing an order, you agree to be bound by all applicable Terms and
          Conditions (TCUS) available on the website, including the Terms and
          Conditions of Sale.{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          reserves the right to accept, refuse, or limit your order for any
          reason, including but not limited to credit review, product
          unavailability, or errors in pricing or product descriptions on the
          website.
        </p>
        <p className={classes.paragraph}>
          By placing your order, you agree that{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems'</b>
          </Link>{" "}
          total liability, under any legal theory or claim, is limited to the
          purchase price actually paid for the product. Shipping and handling
          charges are excluded from this liability and are non-refundable at all
          times.
        </p>
        <h2 className={classes.subheading}>Pricing</h2>
        <p className={classes.paragraph}>
          The Company quotes all prices in US Dollars, exclusive of tax, duty,
          customs, clearance, forwarding duties and charges for international
          orders, including also freight and handling charges in users’ home
          countries. Sales tax is applicable on all products sold to Texas
          customers, therefore, if you are a reseller residing in Texas, you
          will be asked to provide a valid resale tax exemption certificate. If
          you fail to provide us your resale tax exemption certificate, your
          sales tax will not be waived off and it will invalidate all your
          eligible tax exemptions.
        </p>
        <h2 className={classes.subheading}>Delivery Disputes</h2>
        <p className={classes.paragraph}>
          Shipment of all products shall be FOB{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          warehouse, unless otherwise stated.
        </p>
        <p className={classes.paragraph}>
          In case of any damage, delay, or loss during delivery, customers shall
          directly contact and deal with their carrier service.
        </p>
        <p className={classes.paragraph}>
          Customers may provide shipping instructions to the carrier during the
          order placement process. If no instructions are provided,{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          will select a shipping method that best serves the delivery of the
          ordered products. The Company is not liable under any circumstances
          for delays or damages incurred during freight delivery. Additionally,
          if shipment is delayed due to the customer, the Company may store the
          ordered products at the risk and expense of the customer.
        </p>
        <h2 className={classes.subheading}>
          Risk of any Damage or Loss to the Product
        </h2>
        <p className={classes.paragraph}>
          In case of the FOB shipping procedure, any risk, loss, or damage to
          product will be solely passed onto the customer, their representative,
          or freight/carrier service.
        </p>
        <h2 className={classes.subheading}>Order Cancellation</h2>
        <p className={classes.paragraph}>
          Orders accepted by{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          cannot be changed or cancelled by a customer without the written
          consent of{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          or its authorized representatives.
        </p>
        <p className={classes.paragraph}>
          Any order that is cancelled, replaced, or changed will incur a minimum
          handling fee of the greater of $25 or 15% of the order’s value.
        </p>
        <p className={classes.paragraph}>
          To cancel or change an order, customers must contact our customer care
          or sales support during operational hours. Cancellation requests via
          email will not be accepted.
        </p>
        <p className={classes.paragraph}>
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          may, at its discretion, reject or cancel an order due to product
          unavailability or backorder status. Some products listed on the
          website may not always be in stock. Customers are advised to check
          stock availability before placing an order.
        </p>
        <p className={classes.paragraph}>
          If a product is no longer available or out of stock after being
          received for replacement, it will be sent to the RMA Department. In
          such cases, the customer will have two options:
        </p>
        <ul className={classes.subItem}>
          <li>primeCloudSystems send you a comparable replacement item, or</li>{" "}
          <li>
            primeCloudSystems issue a refund valuing the current market value of
            the ordered product. In any such case, the current market value
            price may not exceed the item’s original invoiced price.
          </li>
        </ul>
        <h2 className={classes.subheading}>Jurisdiction Venue</h2>
        <p className={classes.paragraph}>
          In case of commencement of any legal action, to deduce or impose the
          terms of this Agreement, jurisdiction and venue shall be in the
          Municipal or Superior Courts of the, State of Texas, and/or in the
          United States District Court, Central District of Texas, or elsewhere,
          depending upon the mutual agreement of the concerned parties.
        </p>
        <h2 className={classes.subheading}>Central Law & Regulation</h2>
        <p className={classes.paragraph}>
          Any queries with respect to the structure and creation of this
          agreement, rights and responsibilities of the parties, as provided for
          under the documents terms, shall only be determined and set under the
          applicable law of the State of USA.
        </p>
        <h2 className={classes.subheading}>Attorney’s Expense</h2>
        <p className={classes.paragraph}>
          In case any legal act, settlement, proceedings are carried out in
          accordance with the clarifications or implementations of this
          agreement, or concerning a party’s rights, due to any alleged breach
          of agreement, misconduct, or dispute, successful or the principal
          party shall be allowed to recover reasonable attorney’s expenses, or
          other related costs.
        </p>
        <h2 className={classes.subheading}>
          Dropship Requests for Product by Customers
        </h2>
        <p className={classes.paragraph}>
          In case a customer requests our Company to deliver or ship their
          product to a third party, the customer and the final recipient third
          party will both have to be bound by these agreement terms and
          conditions.
        </p>
        <h2 className={classes.subheading}>Conflicting Terms</h2>
        <p className={classes.paragraph}>
          Any terms and conditions included in a customer’s order that conflict
          with the Terms and Conditions of Use (TCUS) of{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          shall be deemed inapplicable unless expressly agreed to in writing by{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>
          . Accordingly, all orders accepted by{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          are subject to and governed by the TCUS.
        </p>
        <h2 className={classes.subheading}>Acceptance and Confirmation</h2>
        <p className={classes.paragraph}>
          Use of [website Name]’s site will create and set up receiving and
          acceptance of the Terms and Conditions of Use mentioned on site. An
          acceptance of any product secured by a customer’s order shall
          constitute an acknowledgement concerning all mentioned TCUS.
        </p>
        <h2 className={classes.subheading}>Purchase Money Security Interest</h2>
        <p className={classes.paragraph}>
          When an order is successfully completed, delivered, and accepted by
          the customer, the customer grants{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          a continuing purchase money security interest in the purchased
          products as security for any due or timely payments under the order.
          This interest extends to all products and any proceeds in which the
          customer holds any right, title, or interest.
        </p>
        <p className={classes.paragraph}>
          Customers agree to cooperate with{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          upon request to complete financing statements, amendments,
          continuation statements, or any other documents necessary to perfect
          or maintain this security interest. Customers shall also bear the cost
          of filing and delivering such documents as reasonably requested.
        </p>
        <p className={classes.paragraph}>
          In the event the customer defaults under this security agreement,{" "}
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          reserves the right to pursue all remedies available under applicable
          law.
        </p>
        <h2 className={classes.subheading}>Copyrights</h2>
        <p className={classes.paragraph}>
          <Link to="https://primecloudsystems.com">
            <b>Prime Cloud Systems</b>
          </Link>{" "}
          makes no representations, express or implied, regarding any
          intellectual property rights it may or may not hold in relation to the
          products listed on its website.
        </p>
      </div>
    </>
  );
}
